// src/pages/Userinfo.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLogOut, FiAlertCircle } from 'react-icons/fi';
import '../styles/userinfo.css';
import { MdSecurity, MdOutlinePassword, MdCleaningServices } from "react-icons/md";
import { IoLanguageOutline, IoSunny, IoMoon } from "react-icons/io5";

function Userinfo() {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);

    const handleLogout = () => {
        // Clear the authentication state
        localStorage.removeItem('isAuthenticated');
        console.log('User logged out. isAuthenticated removed from localStorage');
        // Navigate to login page
        navigate('/login');
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                setUser(JSON.parse(storedUser)); // Parse and set user data
                console.log('User data:', JSON.parse(storedUser)); // Log user data for debugging
            } catch (error) {
                console.error('Error parsing user data:', error);
            }
        }
    }, []);

    return (
        <div className="userinfo-page">
            {/* User Profile Card */}
            <div className="userinfo-content">
                <div className="user-profile-card">
                    <div className="profile-avatar">
                        <img src="/icons/profile.png" alt="User Profile" className="profile-image" />
                    </div>
                    {user ? (
                        <>
                            <h2 className="user-name">{user.username}</h2>
                            <p className="user-email">{user.email}</p>
                        </>
                    ) : (
                        <p>User not logged in</p>
                    )}
                    <button className="logout-button" onClick={handleLogout}>
                        <FiLogOut className="logout-icon" /> LOGOUT
                    </button>
                </div>

                {/* Account Unverified Alert */}
                <div className="unverified-alert">
                    <FiAlertCircle /> Account Unverified
                </div>

                {/* Account Settings */}
                <div className="account-settings">
                    <h3>ACCOUNT SETTING</h3>
                    <div className="account-item">
                        <MdSecurity className="security-icon" />
                        <span className='set-passcode'>Set Passcode</span>
                    </div>
                    <div className="account-item" onClick={() => navigate('/changepassword')}>
                        <MdOutlinePassword color="black" />
                        <span>Change Password</span>
                    </div>
                    <div className="account-item">
                        <IoLanguageOutline color="black" />
                        <span>Change Language</span>
                    </div>
                    <div className="account-item" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                        <IoSunny color='black' />
                        <span>Change color</span>
                    </div>
                    <div className="account-item">
                        <MdCleaningServices color="black" />
                        <span>Clean Application</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Userinfo;